import { sortBy } from 'lodash-es';

import exercisesApi from 'api/rest/exercises/exercises';
import { resolveSubjectNumericId } from 'services/common/subjectParsers/subjectParsers';
import logError from 'utils/logError/logError';

import useSubjectStore from '../subject';

const parseVariables = ({ chosenExercises }) => {
  const { subject } = useSubjectStore.getState();
  const exercisesToFetch = chosenExercises[subject.subjectCode];
  if (!exercisesToFetch) return null;
  return {
    subject: resolveSubjectNumericId(subject),
    indexes: exercisesToFetch.map(({ index }) => index),
  };
};

const getExercisesByIndexes = async variables => {
  const { subject, indexes } = variables;
  if (!subject || !indexes?.length) {
    return {};
  }

  try {
    const page = await exercisesApi.getList({
      subject,
      indexes,
      limit: Math.min(indexes.length, 100),
    })();
    const exercises = sortBy(page.exercises, exercise => indexes.findIndex(index => exercise.index === index));
    const [currentExercise] = exercises;
    return {
      allExercisesCompleted: false,
      exercises,
      currentExercise,
      exercisesCount: exercises.length,
      fetched: true,
    };
  } catch (error) {
    logError(error);
    return {};
  }
};

export { parseVariables };
export default getExercisesByIndexes;
